module.exports = __webpack_public_path__ + "static/img/LogoPMS_old.4306d5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/LogoPMS_old.svg
// module id = /3wm
// module chunks = 15